import { generateRandomGuid4 } from './utils';
export function CorrelationId() {
  var _this = this;

  var _prevCorrelationId = null;
  var _correlationId = null;

  this.get = function () {
    return _correlationId;
  };

  this.getPrevious = function () {
    return _prevCorrelationId;
  };

  this.set = function (correlationId) {
    _prevCorrelationId = _correlationId;
    return _correlationId = correlationId;
  };

  this.randomize = function () {
    return _this.set(generateRandomGuid4());
  };

  this.reset = function () {
    return _this.set(null);
  };
}